import { DATE_FORMAT, today } from '../utils/DateUtils';

export const generateDateArray = (
    amount: number | 'startOf',
    unit: any, format: string,
    opts?: { next?: boolean, includeToday?: boolean }
) => {
    let start;
    let end;

    if (amount === 'startOf') {
        start = today().startOf(unit);
        end = today();
    } else if (opts && opts.next) {
        start = today();
        end = today().add(amount, unit);
    } else {
        start = today().subtract(amount, unit).startOf('d');
        end = today().startOf('d');
        if (opts && opts.includeToday) {
            end.add(1, 'd');
        }
    }

    let days: string[] = [];
    if ( !start.isBefore(end, 'd') ) {
        if (amount === 'startOf') {
            start = start.subtract(1, 'd').startOf(unit);
        } else {
            return days;
        }
    }

    let current = start;
    while (current.isBefore(end, 'd')) {
        days.push( format === 'ISO' ? current.toISOString() : current.format(format) );
        current = current.add(1, 'd');
    }

    //console.log('DAYS', start.format(DATE_FORMAT), end.format(DATE_FORMAT), amount, unit, format, opts, current.format(DATE_FORMAT), days)

    return days;
}

export const last7Days = () => generateDateArray(7, 'days', DATE_FORMAT);
export const last30Days = () => generateDateArray(30, 'days', DATE_FORMAT);
export const mtd = () => generateDateArray('startOf', 'month', DATE_FORMAT);
export const qtd = () => generateDateArray('startOf', 'quarter', DATE_FORMAT);
export const ytd = () => generateDateArray('startOf', 'year', DATE_FORMAT);

export const next7Days = () => generateDateArray(7, 'days', DATE_FORMAT, { next: true });
export const next30Days = () => generateDateArray(30, 'days', DATE_FORMAT, { next: true });

export default {
    last7Days,
    last30Days,
    mtd,
    qtd,
    ytd,
    next7Days,
    next30Days
}